export default {
  // headers / chrome
  bellTitle: "Your notifications",
  viewAll: "View all notifications",
  pageTitle: "All notifications",

  // tabs
  tabAll: "All",
  tabUnread: "Unread",
  tabRead: "Read",

  // empty states
  selectBusiness: "Please select a business profile to view notifications",
  noAlert: "No notifications yet",
  noNew: "No new notifications",
  noList: "No notifications yet",
  notFound: "No matching notifications found",
  checkAgain: "Please check again or contact the administrator",

  // defaults
  unnamed: "Unnamed",
  notSpecified: "Not specified",

  // buttons
  viewProfile: "View Applicant Profile",

  // descriptions
  descViewProfile: "You can view the applicant's profile.",
  descViewStatusList:
    "You can view the full status list of applicants for the {position} position.",

  // notification messages
  msgApplied: "{name} has applied for the position of {position}.",
  msgEditApply:
    "{name} has edited their application for the position of {position}.",
  msgOfferByYou:
    "You have sent a job offer for the position of {position} to {name}.",
  msgOfferByOther:
    "Another administrator has sent a job offer for the position of {position} to {name}.",
  msgStatusByYou:
    "You have changed the application status for the position of {position} of {name} to {status}.",
  msgStatusByOther:
    "Another administrator has changed the application status for the position of {position} of {name} to {status}.",
  msgPaymentInProgress:
    "Applicant {name} for the position of {position} is currently making a payment.",

  // status names
  status: {
    Pending: "No information",
    Interested: "Interested",
    "Pass Screening": "Accepted",
    "Not Pass Screening": "Not accepted",
    "Pass Interview": "Hired",
    "Not Pass Interview": "Failed interview",
    "Waiting Payment": "Waiting for payment",
    "Payment Success": "Payment successful",
    "Payment In Progress": "Payment in progress",
    "Payment Expired": "Expired",
    "Interview In Progress": "Interview in progress",
    "Waiting Interview": "Waiting for interview",
    "Miss Interview": "Missed interview",
  },
};
